export const TRANSFORM_FIELDS = {
    infoFactura: { key: "infoFactura", name: "Información factura" },
    infoNotaCredito: { key: "infoNotaCredito", name: "Información nota de crédito" },
    infoCompRetencion: { key: "infoCompRetencion", name: "Información comprobante de retención" },
    keepAccountingConfirmation: { key: "obligadoContabilidad", name: "SI" },
    infoLiquidacionCompra: { key: "infoLiquidacionCompra", name: "Información liquidación compra" }
}